var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWallet16 = function SvgWallet16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M1 5h9.25c1.633 0 2.45 0 3.077.31a3 3 0 0 1 1.364 1.363C15 7.301 15 8.117 15 9.75s0 2.45-.31 3.077a3 3 0 0 1-1.363 1.364c-.627.309-1.444.309-3.077.309H7c-2.828 0-4.243 0-5.121-.879C1 12.743 1 11.328 1 8.5V5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.991 10h.018"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M10 4c0-.372 0-.558-.03-.712A1.6 1.6 0 0 0 8.711 2.03C8.558 2 8.372 2 8 2H3c-.372 0-.558 0-.712.03A1.6 1.6 0 0 0 1.03 3.289C1 3.442 1 3.628 1 4"
  })));
};
export default SvgWallet16;